import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChecklistEntity } from '../../domain/entities/checklist.entity';
import { ChecklistListItemEntity } from '../../domain/entities/checklist-list-item.entity';
import { InvestigationTypeApi } from '../api/investigation-type.api';
import { ChecklistMapper } from '../mappers/checklist.mapper';

export interface SaveChecklistStepParams {
  id?: string | null;
  description: string;
  displayOrder: number;
}

export interface SaveChecklistParams {
  displayOnInvestigations: boolean;
  steps: SaveChecklistStepParams[];
}

@Injectable({ providedIn: 'root' })
export class ChecklistRepository {
  private readonly _api = inject(InvestigationTypeApi);
  private readonly _mapper = inject(ChecklistMapper);

  public getChecklist(investigationTypeId: string): Observable<ChecklistEntity> {
    return this._api.getChecklist(investigationTypeId).pipe(map((dto) => this._mapper.toDomain(dto)));
  }

  public saveChecklist(investigationTypeId: string, params: SaveChecklistParams): Observable<ChecklistEntity> {
    return this._api
      .saveChecklist(investigationTypeId, {
        displayOnCases: params.displayOnInvestigations,
        steps: params.steps.map((step) => ({
          id: step.id,
          description: step.description,
          displayOrder: step.displayOrder,
        })),
      })
      .pipe(map((dto) => this._mapper.toDomain(dto)));
  }

  public getAllChecklists(): Observable<{ data: ChecklistListItemEntity[]; totalElements: number }> {
    return this._api.getAllChecklists().pipe(
      map((result) => ({
        data: this._mapper.toListItemDomainArray(result.data),
        totalElements: result.totalElements,
      })),
    );
  }

  public deleteChecklist(investigationTypeId: string): Observable<void> {
    return this._api.deleteChecklist(investigationTypeId);
  }

  public toggleChecklistDisplay(investigationTypeId: string, displayOnCases: boolean): Observable<void> {
    return this._api.toggleChecklistDisplay(investigationTypeId, { displayOnCases });
  }
}
